import { render } from "./Settings.vue?vue&type=template&id=2832e562"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "2832e562"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2832e562', script)) {
    api.reload('2832e562', script)
  }
  
  module.hot.accept("./Settings.vue?vue&type=template&id=2832e562", () => {
    api.rerender('2832e562', render)
  })

}

script.__file = "src/components/settings/Settings.vue"

export default script